import { TextField } from "@king-ict/eupisi-ui/components";

type StringListDiffFieldProps = {
  label: string;
  original?: string[];
  corrected?: string[];
  deletedClassName: string;
  addedClassName: string;
};

const normalizeDiffValue = (value: string) => value.trim().toLocaleLowerCase();

const diffStringLists = (oldValues: string[] = [], newValues: string[] = []) => {
  const normalize = (v: string) => v.trim().toLocaleLowerCase();

  const oldNorm = oldValues.map(normalize);
  const newNorm = newValues.map(normalize);

  const newSet = new Set(newNorm);
  const oldSet = new Set(oldNorm);

  const common = oldValues.filter((_, i) => newSet.has(oldNorm[i]));
  const removed = oldValues.filter((_, i) => !newSet.has(oldNorm[i]));
  const added = newValues.filter((_, i) => !oldSet.has(newNorm[i]));

  return { common, removed, added };
};

const joinList = (values: string[]) =>
  values.filter((v) => v && v.trim().length > 0).join(", ");

export const StringListDiffField = ({
  label,
  original,
  corrected,
  deletedClassName,
  addedClassName,
}: StringListDiffFieldProps) => {
  const { common, removed, added } = diffStringLists(original ?? [], corrected ?? []);

  return (
    <div>
      <TextField
        plaintext
        readonly
        label={label}
        value={joinList(common) || "--"}
      />
      {!!removed.length && (
        <div className={deletedClassName}>{joinList(removed)}</div>
      )}
      {!!added.length && (
        <div className={addedClassName}>{joinList(added)}</div>
      )}
    </div>
  );
};

